import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _path;
const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';
function Copy(_ref) {
  let {
      size: sizeProp,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--custom-icon-color, var(--neutral-icon-high-emphasis))",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75V20c0 .5-.5 1-1 1H5.5c-1 0-1.5-.5-1.5-1.5V7c0-.5.5-1 1-1h2.429v10.781c0 1.086.897 1.969 2 1.969H15zm.429-12.094V3h-6a.85.85 0 00-.858.844V16.78a.85.85 0 00.858.844h9.714a.85.85 0 00.857-.844V7.5h-3.714a.853.853 0 01-.857-.844zm4.32-1.09l-2.355-2.319A.864.864 0 0016.788 3h-.217v3.375H20v-.213a.837.837 0 00-.251-.597z"
  })));
}
Copy.sizes = sizes;
Copy.defaultProps = {
  size: sizes.md
};
Copy.propTypes = {
  size: PropTypes.oneOf([Copy.sizes.xs, Copy.sizes.sm, Copy.sizes.md, Copy.sizes.lg, Copy.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default Copy;